<div class="container-fluid px-4 mt-4 mb-5" *ngIf="dataId>0">
    <!-- Page Header -->
    <div class="cp-page-header mb-4">
        <div class="cp-page-title">
            <i class="fa-solid fa-building me-2"></i>
            Editar Instalación
        </div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de Ingreso</a></li>
                <li class="breadcrumb-item"><a routerLink="/control-ingreso/instalaciones/gestion">Instalaciones</a></li>
                <li class="breadcrumb-item active">Editar</li>
            </ol>
        </nav>
    </div>

    <div class="card h-100">
        <div class="card-body">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                <li [ngbNavItem]="1">
                    <a ngbNavLink>INSTALACIÓN</a>
                    <ng-template ngbNavContent>
                        <div class="row">
                            <hr class="mt-0 mb-4">
                            <div class="col-md-8">
                                <div class="card h-100">
                                    <form novalidate [formGroup]="form" (ngSubmit)="update()">
                                        <div class="card-header text-center" style="text-transform: uppercase;">
                                            EDITAR
                                            INSTALACIÓN</div>
                                        <div class="card-body">
                                            <form [formGroup]="form" (ngSubmit)="update()">
                                                <div class="row gx-3 mb-3">
                                                    <div class="col-md-8">
                                                        <label class="small mb-1" for="name">Razón social (50
                                                            max.)</label>
                                                        <div class="input-group">
                                                            <input type="text" class="form-control text-capitalize"
                                                                formControlName="name">
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4">
                                                        <label class="small mb-1" for="rut">RUT</label>
                                                        <div class="input-group mb-3">
                                                            <span class="input-group-text" id="basic-addon1"><i
                                                                    class="fa-solid fa-id-card"></i></span>
                                                            <input (keyup)="onFormatRut($event)" type="text"
                                                                class="form-control" formControlName="rut">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="small mb-1" for="turn">Giro</label>
                                                        <input type="text" class="form-control" formControlName="turn">
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="small mb-1" for="location">Dirección</label>
                                                        <input type="text" class="form-control"
                                                            formControlName="location">
                                                    </div>
                                                    <div class="col-md-8">
                                                        <label class="small mb-1" for="name">Propietario/Gerente
                                                            (50
                                                            max.)</label>
                                                        <div class="input-group">
                                                            <input type="text" class="form-control text-capitalize"
                                                                formControlName="owner">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <label class="small mb-1" for="name">Telefono
                                                            Propietario/Gerente</label>
                                                        <div class="input-group">
                                                            <span class="input-group-text" id="addon-wrapping"><i
                                                                    class="fa-solid fa-phone"></i></span>
                                                            <input type="text" class="form-control text-capitalize"
                                                                formControlName="owner_phone">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="small mb-1" for="email">Email
                                                            Empresa</label>
                                                        <div class="input-group flex-nowrap">
                                                            <span class="input-group-text" id="addon-wrapping"><i
                                                                    class="fa-regular fa-envelope"></i></span>
                                                            <input type="email" class="form-control"
                                                                placeholder="Email  contacto" formControlName="email">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <label class="small mb-1" for="phone">Tel.
                                                            empresa</label>
                                                        <div class="input-group flex-nowrap">
                                                            <span class="input-group-text" id="addon-wrapping"><i
                                                                    class="fa-solid fa-phone"></i></span>
                                                            <input type="email" class="form-control"
                                                                placeholder="Telefono contacto" formControlName="phone">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <option value="0">Mapa (formatos admitidos, jpg, png)
                                                        </option>
                                                        <img (click)="openModal(image,'xl')" class="mb-2"
                                                            style="cursor: pointer; max-height: 200px"
                                                            [src]="form.get('image_path')?.value"
                                                            (error)="handleImageError()" />
                                                    </div>
                                                    <div class="col-md-12">
                                                        <label class="small mb-1" for="name">Panel Informativo</label>
                                                        <div class="border rounded">
                                                            <app-editor-html [form]="form" [controlName]="'content'" style="min-height: 500px;" />
                                                        </div>

                                                    </div>
                                                    <div class="col-md-12 mt-4">
                                                        <label class="small mb-1 text-danger">
                                                            <i class="fa-solid fa-lock me-1"></i>
                                                            Notas Privadas
                                                            <span class="badge bg-danger ms-1">Solo administradores</span>
                                                        </label>
                                                        <div class="border border-danger rounded">
                                                            <app-editor-html [form]="form" [controlName]="'private_content'" style="min-height: 300px;" />
                                                        </div>
                                                    </div>
                                                </div>

                                            </form>
                                        </div>
                                        <div class="card-footer">
                                            <button class="btn btn-primary w-100" type="submit">GUARDAR CAMBIOS
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="col-md-4 mt-5">
                                <app-excel [facility_id]="dataId" />
                            </div>
                        </div>

                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <a ngbNavLink>DEPENDENCIAS</a>
                    <ng-template ngbNavContent>
                        <app-list-stores-facility [facilityId]="dataId" />
                    </ng-template>
                </li>
                <li [ngbNavItem]="3">
                    <a ngbNavLink><i class="fa-solid fa-gear"></i> RONDAS</a>
                    <ng-template ngbNavContent>
                        <app-list-scheduled-rounds [facilityId]="dataId" />
                    </ng-template>
                </li>
                <li [ngbNavItem]="4">
                    <a ngbNavLink><i class="fa-solid fa-list-check"></i> TAREAS</a>
                    <ng-template ngbNavContent>
                        <app-list-tasks-facility [facilityId]="dataId" />
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav"></div>
        </div>
    </div>

</div>

<ng-template #addFacility let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-facility [refModal]="modalRef" (success)="getFacility(); form.get('facility_id')?.setValue($event)" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
<ng-template #image let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-repository-image [showCursor]="true"
            (onSelected)="form.get('image_path')?.setValue($event?.link);d('Cross click')" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>